import { authRequest } from '../domain/authRequest'
import { authResponse } from '../domain/authResponse'
import { IAuthRepository } from '../domain/IAuthRepository'
import { injectable } from 'inversify'
import 'reflect-metadata'
import { http } from '../../../../common/infrastructure/funciones/HelperHttp'
import { IapmUser } from '../../user/domain/iapmUser'
import { appConfigResponse } from '../domain/appConfigResponse'
import { autoAuthRequest } from '../domain/autoAuthRequest'


@injectable()
export class AuthAxiosRepository implements IAuthRepository {
  constructor (urlBase: string) {
    http.initHttp(urlBase)
  }

  async auth (request: authRequest): Promise<authResponse> {
    return (await http.post('/token/auth', request))
  }

  async autoAuth (request: autoAuthRequest): Promise<authResponse> {
    return (await http.post('/token/autoAuth', request))
  }

  async logout () : Promise<boolean> {
    return (await http.post('/user/logout/'))
  }

  async getVersion () : Promise<string> {
    return (await http.get('/version/getVersion/'))
  }

  async whoAmI (): (Promise<IapmUser>) {
    return (await http.post('/user/whoAmI/'))
  }

  async whoAmIProfiles (): (Promise<IapmUser>) {
    return (await http.post('/user/whoAmIProfiles/'))
  }

  async getAppConfig (applicationId: number, applicationVersion: number): (Promise<appConfigResponse>) {
    return (await http.get('/version/getAppConfig/'+ applicationId + '/' + applicationVersion))
  }
  
}
